// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3TwB9","newExpiryDate":"styles_newExpiryDate__3-CNH","footer":"styles_footer__2tD3m"};